document.addEventListener('DOMContentLoaded', () => {

  /* ============================================================
     HEADER MODULE — mobile drawer, sticky header
     ============================================================ */
  (() => {
    const header       = document.getElementById('site-header');
    const backdrop     = document.querySelector('.menu-backdrop');
    const drawer       = document.getElementById('mobile-drawer');
    const hamburger    = document.querySelector('.hamburger');
    const drawerClose  = document.querySelector('.mobile-drawer__close');
    const drawerToggles = document.querySelectorAll('[data-drawer-toggle]');

    if (!header) return;

    /* ---- Escape closes drawer ---- */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (document.body.classList.contains('drawer-open')) {
          closeDrawer();
        }
      }
    });

    /* Backdrop click closes drawer */
    if (backdrop) {
      backdrop.addEventListener('click', () => {
        closeDrawer();
      });
    }

    /* ---- Mobile drawer ---- */
    const openDrawer = () => {
      if (!drawer) return;
      document.body.classList.add('drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      /* Focus first focusable element */
      const first = drawer.querySelector('a, button');
      if (first) first.focus();
      trapFocus(drawer);
    };

    const closeDrawer = () => {
      if (!drawer) return;
      document.body.classList.remove('drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (hamburger) {
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.focus();
      }
    };

    if (hamburger) {
      hamburger.addEventListener('click', () => {
        const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
        if (isOpen) closeDrawer(); else openDrawer();
      });
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    /* Close drawer on link click */
    if (drawer) {
      drawer.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
          setTimeout(closeDrawer, 100);
        });
      });
    }

    /* Drawer sub-menu toggles */
    drawerToggles.forEach(btn => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        const sublist = btn.nextElementSibling;
        if (sublist) sublist.classList.toggle('is-open');
      });
    });

    /* ---- Focus trap for drawer ---- */
    function trapFocus(container) {
      const handler = (e) => {
        if (e.key !== 'Tab') return;
        const focusable = container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last  = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
      /* Store and clean up */
      if (container._trapHandler) {
        document.removeEventListener('keydown', container._trapHandler);
      }
      container._trapHandler = handler;
      document.addEventListener('keydown', handler);

      /* Remove trap when drawer closes */
      const observer = new MutationObserver(() => {
        if (container.getAttribute('aria-hidden') === 'true') {
          document.removeEventListener('keydown', handler);
          container._trapHandler = null;
          observer.disconnect();
        }
      });
      observer.observe(container, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    /* ---- Sticky header ---- */
    const stickyMode = header.getAttribute('data-sticky') || 'always';
    if (stickyMode === 'always') {
      header.classList.add('header--sticky');
    } else if (stickyMode === 'on_scroll_up') {
      header.classList.add('header--sticky');
      let lastScroll = 0;
      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll <= 0) {
          header.classList.remove('scroll-down');
          header.classList.add('scroll-up');
          return;
        }
        if (currentScroll > lastScroll && !header.classList.contains('scroll-down')) {
          header.classList.remove('scroll-up');
          header.classList.add('scroll-down');
        } else if (currentScroll < lastScroll && header.classList.contains('scroll-down')) {
          header.classList.remove('scroll-down');
          header.classList.add('scroll-up');
        }
        lastScroll = currentScroll;
      }, { passive: true });
    }
    /* stickyMode === 'off': header is static, nothing to do */

  })();


  // Sticky Product CTA Mobile Logic
  const buyBox = document.querySelector('.product-buy-box');
  const stickyCTA = document.querySelector('.sticky-mobile-cta');
  if (buyBox && stickyCTA) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && window.innerWidth <= 1024) {
          stickyCTA.classList.add('visible');
        } else {
          stickyCTA.classList.remove('visible');
        }
      });
    }, { rootMargin: "0px", threshold: 0 });
    observer.observe(buyBox);
  }

  // Accordion Logic
  const accordions = document.querySelectorAll('.accordion-header');
  accordions.forEach(acc => {
    acc.addEventListener('click', () => {
      acc.classList.toggle('active');
      const content = acc.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
  // Mobile Slider Auto-scroll (Featured Products only)
  if (window.innerWidth <= 768) {
    const sliders = document.querySelectorAll('.fp-slider');
    sliders.forEach(slider => {
      let scrollInterval;
      const autoScroll = () => {
        clearInterval(scrollInterval);
        scrollInterval = setInterval(() => {
          const itemWidth = slider.firstElementChild ? slider.firstElementChild.offsetWidth + 16 : 300;
          if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 10) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            slider.scrollBy({ left: itemWidth, behavior: 'smooth' });
          }
        }, 3000);
      };
      
      autoScroll();
      slider.addEventListener('touchstart', () => clearInterval(scrollInterval), { passive: true });
      slider.addEventListener('touchend', () => setTimeout(autoScroll, 2000));
    });
  }
});
